<script lang="ts">
  import { onMount } from "svelte";
  import { promoCodeValue, userData, userSignedIn, discount } from "../store";
  import {
    initiateTransaction,
    initiatePremiumMonthly,
    initiatePremiumAnnual,
    initiatePremiumMonthlyDiscount,
  } from "../firebaseOperations";
  import PromoCodeButton from "../buttons/PromoCodeButton.svelte";

  let overlayText = "Please sign in!";
  let overlayMonthly = "";
  let overlayAnnual = "";
  let promoCodeInputValue = "";



  async function purchaseCredits(id: string, credits: number, price: number) {
    if (!$userSignedIn) {
      return;
    }

    await initiateTransaction(id, credits, price);
  }

  async function purchasePremiumMonthly(id: string) {
    if (!$userSignedIn) {
      return;
    }
    await initiatePremiumMonthly(id);
  }

  async function purchasePremiumAnnual(id: string) {
    if (!$userSignedIn) {
      return;
    }
    await initiatePremiumAnnual(id);
  }
  async function purchasePremiumMonthlyDiscount(id: string) {
    if (!$userSignedIn) {
      return;
    }
    await initiatePremiumMonthlyDiscount(id);
  }

  $: userSignedIn.subscribe((value) => {
    if (value) {
      overlayText = "";
      overlayMonthly = "Billed Monthly";
      overlayAnnual = "Billed Annually (33% Off!)";
    } else {
      overlayText = "Please sign in!";
    }
  });

  $: {
    $promoCodeValue = promoCodeInputValue;
  }

  onMount(async () => {
    // wait until the user data is loaded
    console.log($discount);
  });

  // wait until the user data is loaded
</script>

<div id="shop">
  <h3 style="text-align: center;">Shop</h3>
  <div
    style="font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;"
  >
  <div id="creditpurchasesection">
    <p style="text-align: center;">
      Purchase credits to un-cloak and paraphrase text!
    </p>
    <div class="purchase-button-container">
      <div class="embedded-button-container">
        <button
          id="purchaseButton1"
          class:grey-overlay={!$userSignedIn}
          class="purchase-button active-button"
          on:click={() => purchaseCredits($userData.id, 1, 0.99)}
          >Purchase 1 Credit</button
        >
        <div class="overlay-text">{overlayText}</div>
      </div>
      <div class="embedded-button-container">
        <button
          id="purchaseButton2"
          class:grey-overlay={!$userSignedIn}
          class="purchase-button active-button"
          on:click={() => purchaseCredits($userData.id, 5, 0.79)}
          >Purchase 5 Credits</button
        >
        <div class="overlay-text">{overlayText}</div>
      </div>

      <div class="embedded-button-container">
        <button
          id="purchaseButton3"
          class:grey-overlay={!$userSignedIn}
          class="purchase-button active-button"
          on:click={() => purchaseCredits($userData.id, 10, 0.59)}
          >Purchase 10 Credits</button
        >
        <div class="overlay-text">{overlayText}</div>
      </div>
    </div>
  </div>
    <div
      class="purchase-button-container premium-purchase"
      id="purchasepremiumbuttons"
    >
    {#if !$discount}
    <div class="embedded-button-container">
      <button
        id="purchasePremium"
        class:grey-overlay={!$userSignedIn}
        class="purchase-button active-button"
        on:click={() => purchasePremiumMonthly($userData.id)}
        >TextCloaker <span class="shining-text">Premium</span></button
      >
      <div class="overlay-text">{overlayText}</div>
      <div class="overlay-text">{overlayMonthly}</div>
    </div>
    {/if}
    {#if $discount}
    <div class="embedded-button-container">
      <button
        id="purchasePremium"
        class:grey-overlay={!$userSignedIn}
        class="purchase-button active-button"
        on:click={() => purchasePremiumMonthlyDiscount($userData.id)}
        >TextCloaker <span class="shining-text">Premium</span> - (DISCOUNT)</button
      >
      <div class="overlay-text">{overlayText}</div>
      <div class="overlay-text">{overlayMonthly}</div>
    </div>
    {/if}
      <div class="embedded-button-container">
        <button
          id="purchasePremiumAnnual"
          class:grey-overlay={!$userSignedIn}
          class="purchase-button active-button"
          on:click={() => purchasePremiumAnnual($userData.id)}
          >TextCloaker <span class="shining-text">Premium</span></button
        >
        <div class="overlay-text">{overlayText}</div>
        <div class="overlay-text">{overlayAnnual}</div>
      </div>
    </div>
    <p id="purchasetcmessage">
      Purchase TextCloaker Premium for unlimited credits and the highest
      cloaking strength!
    </p>
    <!-- <p class="smallText">
      (You must enter the same email on the checkout page as is connected to
      your account.)
    </p> -->
  </div>
  <h3 style="text-align: center;">Promo Codes</h3>
  <div
    style="font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;"
  >
    <p style="text-align: center;">
      Enter promo codes found in emails and on our social media for
      <span style="color:grey">free credits</span> or even
      <span style="color:grey">premium subscriptions</span>!
    </p>
    <input
      type="text"
      bind:value={promoCodeInputValue}
      id="promocode-textarea"
      placeholder="Enter Promo Code Here"
    />
    <br />
    <PromoCodeButton />
    <br />
    <span id="promoCodeMessage"></span>
  </div>
</div>